// ============================================================
// NEWSLETTER - A DONDE VA EL CORREO
// ------------------------------------------------------------
// MIENTRAS ESTO ESTE VACIO, EL CORREO NO SE GUARDA EN NINGUN LADO.
// El formulario muestra el estado de exito pero la direccion se
// pierde. No lo dejes asi si vas a mandar trafico pago.
//
// Como conectarlo en 2 minutos con GoHighLevel:
//   1. GHL -> Automation -> Workflows -> Create Workflow
//   2. Trigger: "Inbound Webhook"
//   3. Copia la URL que te da y pegala abajo
//   4. Accion siguiente: Create/Update Contact con el campo email
//
// Sirve igual cualquier endpoint que acepte un POST con JSON:
// Zapier, Make, Formspree, un webhook de n8n.
//
// El payload que mandamos es:
//   { email, source: 'blinkblis.com', path, lang, ts }
// ============================================================

export const NEWSLETTER_WEBHOOK = ''

export const isNewsletterLive = () => NEWSLETTER_WEBHOOK.trim().length > 0
